import { FeedRoot, FeedTrigger, FeedContent, FeedPanel, Notification, NotificationProps } from '@notiflows/react';
import '@notiflows/react/styles.css';

const CompactNotification: React.FC<NotificationProps> = (props) => (
  <Notification {...props} showAvatar={false} />
);

export const NotificationPanel: React.FC = () => {
  return (
    <FeedRoot>
      <FeedTrigger />
      <FeedContent side="bottom" align="end">
        <FeedPanel NotificationComponent={CompactNotification} showPreferences={false} />
      </FeedContent>
    </FeedRoot>
  );
};
